import React from 'react';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import JobStatusesSettings from '../../../Components/Settings/JobStatusesSettings';
import { SectionCard, SectionHeader } from '../components/SettingsShell';

const WorkflowSection = ({ onSuccess, onError }) => (
	<SectionCard id="onboarding-job-statuses">
		<SectionHeader
			icon={ViewListOutlinedIcon}
			title="Job statuses"
			description="Customize how you track jobs through your shop."
		/>
		<JobStatusesSettings onSuccess={onSuccess} onError={onError} />
	</SectionCard>
);

export default WorkflowSection;
